import { createBrowserRouter } from "react-router-dom";
import allRoutes from "./routes";
export const Routes = createBrowserRouter([...allRoutes]);
